import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { RejectionReasonComponent } from '@teem/quotes-module/modals/rejection-reason/rejection-reason.component';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ACTIONS as QUOTATION_ACTIONS } from '@teem/constants/quotes';
import { environment } from '@teem/environments/environment';
import { Quotation } from '@teem/models/quotation';
import { Invoice } from '@teem/models/invoice';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';


declare var $;
@Component({
  selector: 'view-quotation',
  templateUrl: './view-quotation.component.html'
})
export class ViewQuotationComponent implements OnInit {
  @Output() changeTab: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() doAction: EventEmitter<any> = new EventEmitter();
  @Output() quotationAction: EventEmitter<any> = new EventEmitter();
  @Input() quotationDetail: Quotation;
  basicInfo: any;

  constructor(
    private sharedDataService: SharedDataService,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit() {
    this.basicInfo = (window as any).userInfo;
    
    // Show/Hide whatsapp action as per pro plan
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.basicInfo = data.userInfo;
      }
    })
    console.log(this.quotationDetail)
  }

  get prefTextColor() {
    return `${this.basicInfo.preference.text_color} !important;`;
  }

  get totalAmount() {
    let items = this.quotationDetail.items ? this.quotationDetail.items : [];
    if (items && items.length > 0) {
      return items.reduce((a, b) => a + this.deliverableCost(b), 0);
    }
    return 0;
  }

  get newDeliverableTax() {
    const invoiceFormValues = this.quotationDetail;
    console.log(this.quotationDetail)
    let taxPercent = this.quotationDetail.tax_percent / 100;
    let taxFinalAmount = 0;
    if (taxPercent) {
      if (invoiceFormValues.tax_type == 1) {
        taxFinalAmount = (this.newInvoiceOriginalAmount * invoiceFormValues.tax_percent / 100);
      } else if (invoiceFormValues.tax_type == 2) {
        taxFinalAmount = (((this.newInvoiceOriginalAmount) / (1 + invoiceFormValues.tax_percent / 100)) * (invoiceFormValues.tax_percent / 100));
      }
    }
    
    return taxFinalAmount;

  }

  get newInvoiceOriginalAmount() {
    console.log('this.newSubTotalDeliverableCost ->',this.newSubTotalDeliverableCost)
    console.log('this.newInvoiceDiscountAmount ->',this.newInvoiceDiscountAmount)
    return (this.newSubTotalDeliverableCost - this.newInvoiceDiscountAmount);
  }

  get newSubTotalDeliverableCost(){
    let items = this.quotationDetail.items ? this.quotationDetail.items : [];
    if (items && items.length > 0) {
      return items.reduce((a, b) => a + this.newDeliverableCost(b), 0);
    }
    return 0;
  }

  newDeliverableCost(deliverableValues: any) {
    let value = deliverableValues.quantity * deliverableValues.rate;
    if (!isNaN(value)) {
      return value;
    }
    return 0;
  }

  get newInvoiceDiscountAmount() {
    let discountAmount = this.quotationDetail.discount;
    let discountType = this.quotationDetail.discount_type;
    if (discountAmount > 0) {
      if (discountType != 'percentage') {
        return discountAmount;
      }
      return (((this.newSubTotalDeliverableCost) / (100) * (discountAmount)));
    } else {
      return this.quotationDetail?.discounted_amount;
    }
    return 0;
  }

  get taxAmount() {

    // let taxPercent = this.quotationDetail.tax_percent / 100;

    // if (taxPercent) {
    //   let items = this.quotationDetail.items ? this.quotationDetail.items : [];
    //   if (items && items.length > 0) {
    //     return items.reduce((a, b) => a + this.deliverableTax(b), 0);
    //   }
    // }
    // return 0;
    let items = this.quotationDetail.items ? this.quotationDetail.items : [];
    if (items && items.length > 0) {
      return items.reduce((a, b) => a + this.deliverableTax(b), 0);
    }
    return 0;
  }

  deliverableTax(deliverable: any) {
    return (deliverable.quantity * deliverable.rate * this.quotationDetail.tax_percent / 100);
  }

  deliverableCost(deliverable: any) {
    let value = deliverable.quantity * deliverable.rate;
    // let value = deliverable.quantity * deliverable.rate + this.deliverableTax(deliverable);

    if (!isNaN(value)) {
      return value;
    }
    return 0;
  }

  saveAsPdf() {
    (window as any).open(`${environment.baseUrl}/download/quotation/${this.quotationDetail.uuid}/pdf?lang=${(window as any).LOCALE}`, '_self', 'location=yes');
  }

  emailQuotation() {
    this.doAction.emit({ action: QUOTATION_ACTIONS.EMAIL, quotation: this.quotationDetail });
  }

  deleteQuotation() {
    this.onDelete.emit(this.quotationDetail);
  }

  editQuotation() {
    this.onEdit.emit(this.quotationDetail);
  }

  whatsappQuotation() {
    this.doAction.emit({ action: QUOTATION_ACTIONS.WHATSAPP, quotation: this.quotationDetail });
  }

  quotationActions(action) {
    switch (action) {
      case "accept":
        // this.emailQuotations([obj.quotation.uuid]);
        if(this.quotationDetail.status != "approved" ){
          Swal.fire({
            title: i18n.are_you_sure_want_accept_quatation,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#ee3a7a',
            confirmButtonText:
              i18n.accept_quatation,
            cancelButtonText:
              i18n.cancel
          }).then(result => {
            if (result.value) {
              this.quotationAction.emit({ uuid: [this.quotationDetail.uuid], action: action });
            }
          });
        }
        break;
      case "reject-only":
        if(this.quotationDetail.status != "rejected" ){
          Swal.fire({
            title: i18n.are_you_sure_want_reject_quatation,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#ee3a7a',
            confirmButtonText:
              i18n.reject_resend,
            cancelButtonText:
              i18n.cancel
          }).then(result => {
            if (result.value) {
              this.quotationAction.emit({ uuid: this.quotationDetail.uuid, action: 'reject' });
            }
          });
        }
        break;
      case "reject":
        if(this.quotationDetail.status != 'rejected'){
          const modalRef = this.modalService.open(RejectionReasonComponent);
          modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "negotiate-modal";
          modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.classList.add("quotation-modal");
          modalRef.componentInstance.quotationAction = this.quotationAction;
          modalRef.componentInstance.quotationDetail = this.quotationDetail;
          modalRef.result.then(data => {
            console.log("view quotation comp" + data)
          }, fallbackResult => {
            // do nothing
          })
          // this.quotationAction.emit({ uuid: this.quotationDetail.uuid, action: action,  rejected_reason =   });
        }
        break;
      case "edit":
        this.onEdit.emit(this.quotationDetail);
        break;
      case "convert_to_invoice":
        this.quotationAction.emit({ uuid: [this.quotationDetail.uuid], action: action });
        break
    }
  }
}
